export default "__VITE_ASSET__be7bafbd__"